import { useContext } from 'react';

import MasterContext from './master.context';
import type { ContextValue } from './type';

export function useMaster(): ContextValue {
  return useContext(MasterContext);
}
